import localForage from 'localforage';
import { type PersistorConfig } from 'redux-persist';
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import immutableTransform from 'redux-persist-transform-immutable';

import { buildRootReducer } from '../reducers/Index';
import tempImmutableTransform from '../tools/ImmutableMigrationTransform';

import { type Store } from './types';

export function injectReducer(store: Store, name: string, asyncReducer: $TSFixMe): void {
  // Injecting multiple reducers
  if (typeof asyncReducer === 'object') {
    for (const reducerName of Object.keys(asyncReducer)) {
      injectReducer(store, reducerName, asyncReducer[reducerName]);
    }
    return;
  }
  if (!store.asyncReducers) store.asyncReducers = {};
  store.asyncReducers[name] = asyncReducer;
  store.replaceReducer(buildRootReducer(store.asyncReducers));
}

/**
 * redux-persist config factory used to normalize configuration between persistors
 *
 * @param config - the config to override default persistConfig
 */
export function createPersistConfig(config: Partial<PersistorConfig>): PersistorConfig {
  localForage.config({
    name: 'Pandora Web',
  });

  const defaultConfig = {
    storage: localForage,
    transforms: [immutableTransform({}), tempImmutableTransform()],
    whitelist: [], // by default disable all
  };

  return Object.assign(defaultConfig, config);
}
